import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCTS_API
} from '../../../constants/API';
import {
  GET_PRODUCTS_DUPLICATE_SKUS_LOADING,
  GET_PRODUCTS_DUPLICATE_SKUS
} from '../types';

function getProductsWithDuplicateSkus() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_PRODUCTS_DUPLICATE_SKUS_LOADING,
      loadingProductsWithDuplicateSkus: true
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const { userData } = getState().AuthReducer;

      const productsWithDuplicateSkusResponse = await axios.get(
        `${PRODUCTS_API}/duplicateSkus?userId=${userData.id}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      console.log(productsWithDuplicateSkusResponse)
      dispatch({
        type: GET_PRODUCTS_DUPLICATE_SKUS,
        loadingProductsWithDuplicateSkus: false,
        productsWithDuplicateSkus: productsWithDuplicateSkusResponse.data
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: GET_PRODUCTS_DUPLICATE_SKUS_LOADING,
        loadingProductsWithDuplicateSkus: false
      });
    }
  };
}
export default getProductsWithDuplicateSkus;
